/**
 * Block checkout when the cart has 1–2 wax melts.
 * Liquid (melt-qty-guard) is the source of truth; this keeps buttons in sync
 * after Ajax cart updates and stops checkout clicks / wallet buttons.
 */
(function () {
  function guardNode() {
    return document.querySelector('[data-melt-guard]');
  }

  function isBlocked() {
    var node = guardNode();
    return !!(node && node.getAttribute('data-melt-blocked') === 'true');
  }

  function cartLooksEmpty() {
    var drawer = document.querySelector('cart-drawer');
    var footer = document.getElementById('main-cart-footer');
    if (drawer && drawer.classList.contains('is-empty')) return true;
    if (footer && footer.classList.contains('is-empty')) return true;
    return false;
  }

  function apply() {
    var blocked = isBlocked();
    document.querySelectorAll('#checkout, #CartDrawer-Checkout, button[name="checkout"]').forEach(function (btn) {
      if (blocked || cartLooksEmpty()) {
        btn.setAttribute('disabled', 'disabled');
        btn.setAttribute('aria-disabled', 'true');
      } else {
        btn.removeAttribute('disabled');
        btn.removeAttribute('aria-disabled');
      }
    });
    document.querySelectorAll('.additional-checkout-buttons, .cart__dynamic-checkout-buttons').forEach(function (el) {
      el.hidden = blocked;
    });
  }

  function blockEvent(event) {
    if (!isBlocked()) return;
    event.preventDefault();
    event.stopPropagation();
    apply();
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target.closest('button[name="checkout"], #checkout, #CartDrawer-Checkout, a[href*="/checkout"]');
      if (target) blockEvent(event);
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      if (!isBlocked()) return;
      var submitter = event.submitter;
      if (submitter && (submitter.name === 'checkout' || submitter.id === 'checkout' || submitter.id === 'CartDrawer-Checkout')) {
        blockEvent(event);
      }
    },
    true
  );

  document.addEventListener('DOMContentLoaded', apply);
  apply();

  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      setTimeout(apply, 60);
    });
  }

  var observed = document.getElementById('main-cart-footer') || document.querySelector('cart-drawer');
  if (observed && window.MutationObserver) {
    new MutationObserver(apply).observe(observed, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['data-melt-blocked'],
    });
  }
})();
